import axios from "axios";
import API_VERSION from "../data/api-version";

const ShopifyGetCollection = async (id) => {
  try {
    const response = await axios({
      url: `https://${process.env.REACT_APP_SHOP_URL}/api/${API_VERSION}/graphql.json`,
      method: "POST",
      headers: {
        "X-Shopify-Storefront-Access-Token": process.env.REACT_APP_SHOP_ACCESS_TOKEN,
      },
      data: {
        query: `{
          collection(id: "${id}") {
            id
            products(first:50) {
              edges {
                node {
                  id
                  title
                  featuredImage {
                    url(transform: {maxHeight: 500})
                  }
                  points: metafield(key:"patch_points", namespace:"my_fields") {
                    value
                  }
                  width: metafield(key:"patch_width", namespace:"my_fields") {
                    value
                  }
                  height: metafield(key:"patch_height", namespace:"my_fields") {
                    value
                  }
                  material: metafield(key:"patch_material", namespace:"my_fields") {
                    value
                  }
                  centerback: metafield(key:"patch_centerback", namespace:"my_fields") {
                    value
                  }
                  totalInventory
                  variants(first:1) {
                    edges {
                      node {
                        id
                      }
                    }
                  }
                }
              }
            }
          }
        }`,
      },
    });
    if (response.data.data.collection) {
      const { collection } = response.data.data;
      return {
        id: collection.id,
        patches: collection.products.edges
          .filter((e) => !!e.node.points && !!e.node.width && !!e.node.height)
          .map((patch) => ({
            id: patch.node.id,
            vid: patch.node.variants.edges[0].node.id,
            title: patch.node.title,
            src: patch.node.featuredImage ? patch.node.featuredImage.url : "",
            points: parseInt(patch.node.points.value),
            width: JSON.parse(patch.node.width.value).value,
            height: JSON.parse(patch.node.height.value).value,
            material: patch.node.material ? patch.node.material.value : "",
            centerback: patch.node.centerback ? patch.node.centerback.value === "true" : false,
            inventory: patch.node.totalInventory,
          })),
      };
    } else {
      return null;
    }
  } catch (e) {
    console.log(e);
    return null;
  }
};

export default ShopifyGetCollection;
